<template lang="pug">
v-container.pa-2.overflow-y-auto(:fluid='true' :style='baseContainerStyle')
    v-toolbar(density='compact')
        v-toolbar-title(v-bind='$attrs')
            v-icon.mr-4(v-if='icon' size='small' :color='iconColor') {{ icon }}
            | {{ title }}
        slot(name='special-actions')

        v-spacer
        slot(name='actions')
        template(v-if='$slots.extension' v-slot:extension)
            slot(name='extension')
    // `type='heading card divider actions'` seems to cause an error,
    //      although it should work according to the documentation.
    //v-skeleton-loader(type='heading card divider actions' :loading="true")
    // Using a slot as follows messes up how the content in the slot is displayed
    //v-skeleton-loader(type='table' :loading="loading")
    //    slot(name='default')
    v-skeleton-loader(type='table' v-if='loading')
    slot(name='default' v-else)
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BaseSimpleView',
    inheritAttrs: false,
    props: {
        icon: {
            type: String,
            default: undefined,
        },
        iconColor: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        dataCy: {
            type: String,
            default: undefined,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        baseContainerStyle: {
            type: String,
            // `height: 93vh` works with the breadcrumbs to not require vertical scrolling.
            // This requires the window to have full height, which is usually a reasonable assumption.
            default: 'height: 93vh',
        },
    },
});
</script>
